<template>
  <div v-if="baseValue.type === 'text' || type === 'text' || type === 'textbox' || baseValue.type === 'textbox'">
    <NameAndText :baseValue="baseValue" @formAddEvent="emitChildEvent"></NameAndText>
  </div>

  <div v-if="baseValue.type === 'checkbox' || type === 'checkbox' || baseValue.type === 'multiCheckbox' || type === 'multiCheckbox'">
    <CheckboxOrMulti :baseValue="baseValue" @formAddEvent="emitChildEvent"></CheckboxOrMulti>
  </div>

  <div v-if="type === 'multiTextBox' || baseValue.type === 'multiTextBox'">
    <MultiTextBox :baseValue="baseValue" @formAddEvent="emitChildEvent"></MultiTextBox>
  </div>
  
  <div v-if="baseValue.type === 'checkboxWithText' || type === 'checkboxWithText'">
    <CheckboxWithTextComponent :baseValue="baseValue" @formAddEvent="emitChildEvent"></CheckboxWithTextComponent>
  </div>

  <div v-if="baseValue.type === 'largeText' || type === 'largeText' || baseValue.type === 'institute' || type === 'institute'">
    <LargeTextComponent  @formAddEvent="emitChildEvent" :baseValue="baseValue"></LargeTextComponent>
  </div> 

  <div v-if="baseValue.type === 'md' || type === 'md'">
    <m-d :baseValue="baseValue" @formAddEvent="emitChildEvent"></m-d>
  </div>

  <div v-if="baseValue.type === 'img' || type === 'img'">
    <image-component :baseValue="baseValue" @formAddEvent="emitChildEvent"></image-component>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import NameAndText from './NameAndText.vue'
import CheckboxOrMulti from './CheckboxOrMulti.vue'
import ImageComponent from './Image.vue'
import MD from './MD.vue'
import CheckboxWithTextComponent from './CheckboxWithText.vue'
import LargeTextComponent from './LargeText.vue'
import MultiTextBox from './MultiTextBox.vue'

export default defineComponent({
  name: 'ComponentProvider',
  components: {
    NameAndText,
    CheckboxOrMulti,
    CheckboxWithTextComponent,
    LargeTextComponent,
    MD,
    ImageComponent,
    MultiTextBox
  },
  emits: ['formAddEvent'],
  props: {
    type: String,
    baseValue: Object,
  },
  methods: {
    emitChildEvent(data) {
      // Forward the event to the parent component
      data.type = this.type || this.baseValue.type
      this.$emit('formAddEvent', data);
    }
  }
})
</script>
